module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-21GENNAIO-25-small-cca9f3652cbc5ddd8b1abe058e93b8dd.png";